/**
 * Frontend logger — attivo solo in development.
 * In produzione i log sono disabilitati per performance e privacy.
 *
 * Uso: import { log } from '../utils/logger';
 *       log.info('Auth', 'Login successful', { userId });
 */

const isDev = import.meta.env.DEV;

type LogData = Record<string, unknown> | undefined;

function formatMsg(context: string, msg: string, data?: LogData): string {
  const timestamp = new Date().toISOString().slice(11, 23);
  return `[${timestamp}] ${context}: ${msg}`;
}

export const log = {
  info(context: string, msg: string, data?: LogData): void {
    if (!isDev) return;
    if (data) {
      console.log(`%c${formatMsg(context, msg)}`, 'color: #2C5F2D', data);
    } else {
      console.log(`%c${formatMsg(context, msg)}`, 'color: #2C5F2D');
    }
  },

  warn(context: string, msg: string, data?: LogData): void {
    if (!isDev) return;
    if (data) {
      console.warn(formatMsg(context, msg), data);
    } else {
      console.warn(formatMsg(context, msg));
    }
  },

  error(context: string, msg: string, err?: unknown): void {
    if (!isDev) return;
    console.error(formatMsg(context, msg), err ?? '');
  },
};
